import { baseColors, darkColors, lightColors } from '../../theme/colors';
import { ButtonTheme, variants } from './Button.types';

const { PRIMARY, SECONDARY, GREY, TEXTGREY, WHITE, UNIVERSAL } = variants;

export const dark: ButtonTheme = {
  [PRIMARY]: {
    background: darkColors.white,
    backgroundActive: 'none',
    backgroundHover: darkColors.white,
    border: `1px solid transparent`,
    borderColorHover: 'transparent',
    boxShadow: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    boxShadowActive: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    color: 'black',
    colorHover: 'black',
    spinnerColor: 'black',
    spinnerColorHover: 'black'
  },
  [SECONDARY]: {
    background: darkColors.primary,
    backgroundActive: 'none',
    backgroundHover: 'none',
    border: `1px solid transparent`,
    borderColorHover: 'transparent',
    boxShadow: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    boxShadowActive: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    color: '#16161D',
    colorHover: 'white'
  },
  [GREY]: {
    background: darkColors.primary,
    backgroundActive: 'none',
    backgroundHover: 'none',
    border: `1px solid transparent`,
    borderColorHover: 'transparent',
    boxShadow: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    boxShadowActive: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    color: '#16161D',
    colorHover: 'white'
  },
  [TEXTGREY]: {
    background: darkColors.primary,
    backgroundActive: 'none',
    backgroundHover: 'none',
    border: `1px solid transparent`,
    borderColorHover: 'transparent',
    boxShadow: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    boxShadowActive: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    color: '#16161D',
    colorHover: 'white'
  },
  [WHITE]: {
    background: '#3B3C43',
    backgroundActive: '#3B3C43',
    backgroundHover: '#3B3C43',
    border: '1px solid #FFFFFF',
    borderColorHover: '1px solid #FFFFFF',
    boxShadow: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    boxShadowActive: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    color: darkColors.white,
    colorHover: darkColors.white
  },
  [UNIVERSAL]: {
    background: lightColors.primary,
    backgroundActive: 'none',
    backgroundHover: baseColors.d3gray,
    border: `1px solid transparent`,
    borderColorHover: 'transparent',
    boxShadow: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    boxShadowActive: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    color: baseColors.white,
    colorHover: 'white'
  }
};

export const light: ButtonTheme = {
  [PRIMARY]: {
    background: lightColors.primary,
    backgroundActive: 'none',
    backgroundHover: baseColors.white,
    border: `1px solid transparent`,
    borderColorHover: 'black',
    boxShadow: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    boxShadowActive: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    color: 'white',
    colorHover: 'black',
    spinnerColor: 'white',
    spinnerColorHover: 'grey'
  },
  [SECONDARY]: {
    background: lightColors.primary,
    backgroundActive: 'none',
    backgroundHover: 'none',
    border: `1px solid transparent`,
    borderColorHover: 'transparent',
    boxShadow: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    boxShadowActive: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    color: '#16161D',
    colorHover: 'white'
  },
  [GREY]: {
    background: lightColors.primary,
    backgroundActive: 'none',
    backgroundHover: 'none',
    border: `1px solid transparent`,
    borderColorHover: 'transparent',
    boxShadow: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    boxShadowActive: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    color: '#16161D',
    colorHover: 'white'
  },
  [TEXTGREY]: {
    background: lightColors.primary,
    backgroundActive: 'none',
    backgroundHover: 'none',
    border: `1px solid transparent`,
    borderColorHover: 'transparent',
    boxShadow: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    boxShadowActive: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    color: '#16161D',
    colorHover: 'white'
  },
  [WHITE]: {
    background: darkColors.white,
    backgroundActive: 'none',
    backgroundHover: 'none',
    border: '1px solid #16161D',
    borderColorHover: '#16161D',
    boxShadow: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    boxShadowActive: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    color: '#16161D',
    colorHover: '#16161D',
    spinnerColor: 'grey',
    spinnerColorHover: 'grey'
  },
  [UNIVERSAL]: {
    background: lightColors.primary,
    backgroundActive: 'none',
    backgroundHover: baseColors.d3gray,
    border: `1px solid transparent`,
    borderColorHover: 'transparent',
    boxShadow: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    boxShadowActive: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
    color: baseColors.white,
    colorHover: 'white'
  }
};
